import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import seven from '../assets/svg/projects/seven.svg'
import eleven from '../assets/svg/projects/eleven.svg'
import ten from '../assets/svg/projects/ten.svg'
import twelve from '../assets/svg/projects/twelve.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'xStack',
        projectDesc: 'A module developed as a part of an ERP for tracking attendance, requesting and granting leave and on-duty.',
        tags: ['Bootstrap', 'PHP', 'MySQL', 'JavaScript'],
        code: '',
        demo: '',
        image: seven
    },
    {
        id: 2,
        projectName: 'Rehoboth',
        projectDesc: 'A dynamic website for a packaging and lashings company in Chennai.',
        tags: ['Bootstrap', 'CSS', 'Material Ui'],
        code: '',
        demo: 'https://rehobothpackaging.com/',
        image: two
    },
    {
        id: 3,
        projectName: 'Bothub',
        projectDesc: 'A e-commerce website for a coimbatore based startup company.',
        tags: ['React', 'CSS', 'Python-FastAPI','MySQL'],
        code: '',
        demo: '',
        image: ten
    },
    {
        id: 4,
        projectName: 'Zue Technologies',
        projectDesc: 'A minimal portfolio page for an organization.',
        tags: ['React', 'CSS', 'Framer Motion'],
        code: '',
        demo: '',
        image: four
    },
    {
        id: 5,
        projectName: 'Project Cortex',
        projectDesc: 'An ERP suite for any organization.',
        tags: ['ReactJS', 'TypeScript', 'NodeJS', 'PostgreSQL', 'Python-Flask', 'Firebase'],
        code: '',
        demo: '',
        image: one
    },
    {
        id: 6,
        projectName: 'PTSI website',
        projectDesc: 'An interactive website for a NGO at Malaysia that aims to help the poor and needy in the community.',
        tags: ['Figma', 'CSS', 'Bootstrap','JavaScript'] ,
        code: '',
        demo: 'https://ptsi.edu.my/',
        image: three
    },
    {
        id: 7,
        projectName: 'Fablab manager',
        projectDesc: 'A simple booking app for a fabrication lab.',
        tags: ['React Native', 'NodeJS', 'ExpressJS', 'PostgreSQL'],
        code: '',
        demo: '',
        image: twelve
    },
    {
        id: 8,
        projectName: 'Estates India',
        projectDesc: 'A website for a real estate company in Chennai.',
        tags: ['Figma', 'CSS', 'Bootstrap','JavaScript'] ,
        code: '',
        demo: 'https://estatesindia.in/',
        image: eleven
    },
]
